import React, { useState } from "react";
import { useSelector } from "react-redux";
import { SEND_SMS } from "utils/mutations";
import { useMutation } from "@apollo/react-hooks";
import { useHistory } from "react-router";
import {
  ExpansionPanel as Panel,
  ExpansionPanelSummary as Summary,
  ExpansionPanelDetails as Details,
} from "@material-ui/core/";
import SMSPhoneInput from "../utils/components/sms/SMSPhoneInput";
import SMSChatBubblePreview from "../utils/components/sms/SMSChatBubblePreview";
import MarketingNavigation from "../utils/components/MarketingNavigation";
import SMSMarketingStepper from "../utils/components/sms/SMSMarketingStepper";
import SMSUploadContainer from "../utils/components/sms/SMSUploadContainer";
import MarketingButtons from "../utils/components/MarketingButtons";
import MarketingToolTip from "../utils/components/MarketingToolTip";

const SMSReview = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(null);
  const [testNumber, setTestNumber] = useState();
  const [sendSms] = useMutation(SEND_SMS);
  const emailList = useSelector((state) => state.smsBatching.emailList);
  const batchName = useSelector((state) => state.smsBatching.batchName);
  const message = useSelector((state) => state.smsBatching.message);
  const fileName = useSelector((state) => state.smsBatching.fileName);
  const Icon = [<i key="icon" className="fas fa-ellipsis-h text-black" />];
  const history = useHistory();

  const handleSendSms = async () => {
    setLoading(true);
    if (!message || !testNumber) {
      setLoading(false);
      setSuccess(false);
    }
    const payload = {
      body: message,
      data: JSON.stringify(emailList),
      batchName,
    };
    await sendSms({ variables: payload }).then((response) => {
      console.log(response);
      if (response.data.sendSMS.status === `SUCCESS`) {
        setSuccess(true);
        setLoading(false);
        history.push("/marketing/sms/results");
      }
      setError(true);
      setLoading(false);
    });
  };
  return (
    <div className="marketing-container flex flex-col bg-transparent mb-4">
      <MarketingNavigation>
        <MarketingToolTip>
          <small className="text-black-500">
            <i className="fas fa-exclamation-circle mr-2 text-gray-600" />
            <span className="text-red-500">Review and test </span>
            the campaign details before submitting.
          </small>
        </MarketingToolTip>
      </MarketingNavigation>
      <SMSMarketingStepper />
      <p className="text-3xl text-center mx-auto my-10">
        Review and Submit Batch :
      </p>
      <div className="flex flex-col justify-center rounded-lg review-panel">
        <Panel>
          <Summary expandIcon={Icon} aria-label="Expand">
            Batch Preview
          </Summary>
          <Details>
            <SMSChatBubblePreview setError={setError} key="chat_preview" />
            {error && <small>{error}</small>}
          </Details>
        </Panel>
        <Panel>
          <Summary expandIcon={Icon} aria-label="Expand">
            Audience
          </Summary>
          <Details>
            <SMSUploadContainer
              key="upload_container"
              emailList={emailList}
              fileName={fileName}
            />
          </Details>
        </Panel>
        <Panel>
          <Summary expandIcon={Icon} aria-label="Expand">
            Send Test SMS
            <small className="text-green-500 ml-2 my-auto">recommended</small>
          </Summary>
          <Details>
            <SMSPhoneInput
              key="phone_input"
              testNumber={testNumber}
              setTestNumber={setTestNumber}
            />
          </Details>
        </Panel>
      </div>
      <MarketingButtons
        prevLink="/marketing/sms/upload"
        prevButton="Previous"
        nextLink="/marketing/sms/results"
        nextButton="Submit"
        required={!message || !emailList}
        submit={handleSendSms}
        success={success}
        loading={loading}
        error={error}
      />
    </div>
  );
};

export default SMSReview;
